<template>
  <div class="flex-home">
    <div class="pageTitle">{{ $route.meta.title }}</div>
    <TableView :labels="labels" ref="TableView" apiName="GetSupplierPeopleDeliverablePageList" :searchList="searchList">
      <template slot="table-item">
        <el-table-column label="操作" width="160" fixed="right" v-slot="{ row }">
          <el-button type="text" @click="$refs.Detail.open(row)">查看</el-button>
          <el-button
            v-if="row.updateState == '待上传'"
            type="text"
            @click="showUpload(row, 1)"
            >上传</el-button
        </el-table-column>
      </template>
    </TableView>
    <Detail ref="Detail"></Detail>
    <!-- <UploadFile ref="UploadFile" @updateList="$refs.TableView.refreshTable()"></UploadFile> -->
    <UploadPeople ref="UploadPeople" @submit="updataList"></UploadPeople>
  </div>
</template>

<script>
import Detail from './info.vue'
import { searchDeliverableSign } from '@/configs/searches.js'
import { tableDeliverableSign } from '@/configs/tables.js'
import { downloadDocx, downloadUrl } from '@/utils'
import MultipleUpload from '@/components/formView/multipleUpload.vue'
import UploadPeople from './uploadDlieverableSign.vue'
export default {
  components: { Detail, MultipleUpload, UploadPeople },
  data() {
    return {
      btnloadSubmit: false,
      labels: tableDeliverableSign,
      searchList: searchDeliverableSign,
      show: false,
      fileType: -1,
      detail: {
        deliverableList: [],
        acceptanceList: [],
        deliverableId: '',
        beEnterprise: '',
        taskNo: '',
        taskName: ''
      },
      fileSuffix: ['jpg', 'png', 'jpeg', 'pdf', 'zip', 'rar', 'txt'],
      config: {
        disabled: false
      }
    }
  },
  methods: {
    async downLoadWd() {
      const result = await this.$api.DownloadAcceptanceNoteFile({ id: this.detail.deliverableId, type: 2 })
      downloadDocx(result, '成果验收单')
    },
    uploadMul(val) {
      console.log(val)
      this.fileType == 1 ? (this.detail.deliverableList = val) : (this.detail.acceptanceList = val)
    },
    // 下载模板
    async download() {
      const result = await this.$api.DownloadTaskDeliverableFile()
      downloadDocx(result, '交付物模板下载')
    },
    downloadFile(e, type) {
      if (type == 1 && e.deliverableList.length > 0) {
        e.deliverableList.map((item) => {
          downloadUrl(item.url)
        })
      } else if (type == 2 && e.acceptanceList.length > 0) {
        e.acceptanceList.map((item) => {
          downloadUrl(item.url)
        })
      } else {
        this.$message.error('暂无文件')
      }
    },
    filterType(e, type) {
      //type:1:交付物,2:创客成果验收单
      let v = e.filter((item) => {
        return item.attachType == type
      })
      return v
    },
    showUpload(e, type) {
      let { id } = e;
      let detail = Object.assign({ id })
      this.$refs.UploadPeople.open(detail)
    },
    updataList(){
      this.$refs.TableView.refreshTable()
    },
    async submit() {
      if (this.detail.deliverableList.length == 0 && this.detail.acceptanceList.length == 0) {
        this.$message.error('请上传文件')
        return false
      }
      this.btnloadSubmit = true
      if (this.fileType == 1) {
        this.detail.deliverableList.map((item) => {
          item.url = item.fileUrl
          item.name = item.fileName
        })
      } else {
        this.detail.acceptanceList.map((item) => {
          item.url = item.fileUrl
          item.name = item.fileName
        })
      }
      const result = await this.$api.UploadTaskDeliverable(this.detail).finally(() => {
        this.btnloadSubmit = false
      })
      if (result) {
        this.$message.success('上传成功')
        this.show = false
        this.$refs.TableView.refreshTable()
      }
    }
  }
}
</script>